export class Customer {
    public CustomerID: string = '';
    public RegistrationDate: Date;
    public CompanyName: string = '';
    public Name: string = '';
    public Address: string = '';
    public VATNumber: string = '';
    public Zip: string = '';
    public City: string = '';
    public County: string = '';
    public Prefix: string = '';
    public Phone: string = '';
    public Fax: string = '';
    public Country: string = '';
    public FiscalCode: string = '';
    public Email: string = '';
    public PECEmail: string = '';
    public AccountName: string = '';
    public PartnerCode: string = '';
    public SDICode: string = '';
    public BranchID: number = 0;
    public Disabled: number = 0;
    public UserID: string = '';
    public CustSupp: string = '';
    public coupon: string = '';
    public paymentPeriodicity: number = 0;
    public wantFEVaucher: boolean = false;
    public PersonalDataAgreeInt: boolean = false;
    public PersonalDataAgreeExt: boolean = false;
    public CompanyCode: string = '';
    public CompanyType: number;
    public PartnershipLevel: string = '';
    public AdminLogin: string = '';
    public ParentCompany: string = '';
    public SubscriptionKey: string = '';
}

export const CodiceAziendaZucchetti: string = '000000000000001';
export class CustSuppData extends Customer {
    public Payment: string = '37093376'; //indefinito;
    public PaymentDescription: string = '';
    public InstallmentType: number;
}

export enum CustomerType {
    Rivenditore = 36700160,
}

export enum MandatiMago {
    SILVER = 'SILVER', //BUSINESS
    GOLD = 'GOLD', //PREMIUM
    PLATINUM = 'PLATINUM', //EXCELLENCE
}

export class PartnershipLevel {
    contractName: string;
    contractValue: string;
}

export class AmazonDspContact {
    Name: string = '';
    Email: string = '';
    CompanyName: string = '';
    Notes: string = '';
    Phone: string = '';
    Country: string = '';
}

export class GenericContactForLogin {
    Name: string = '';
    Email: string = '';
    CompanyName: string = '';
    ContactType: string = '';
}

export class TrainingContact {
    constructor() {
        (this.CompanyName = ''),
            (this.RequestFor = ''),
            (this.FunctionalArea = []),
            (this.Environment = []),
            (this.Request = ''),
            (this.TrainingType = new TrainingType());
    }

    CompanyName: string = '';
    RequestFor: string = '';
    TrainingType: TrainingType;
    FunctionalArea: string[];
    Environment: string[];
    Request: string = '';
}
export class TrainingType {
    constructor() {
        this.Type = TrainingTypes.Remotely;
        this.Details = '';
    }
    Type: TrainingTypes = TrainingTypes.Remotely;
    Details: string = '';
}
export enum TrainingTypes {
    Remotely = 'Remoto',
    OnSite = 'In sede',
    Other = 'Altro',
}

export class ContactInfo {
    SupportEmailInt: string = '';
    SupportEmailLOC: string = '';
    MacroFunctionalArea: number = 0;
    Telephone: string = '';
    MacroAreaFunzionaleDescri: string = '';
}

export enum StatoAnomalia {
    'Da esaminare' = 33292288,
    'Da risolvere' = 33292289,
    'No anomalie' = 33292290,
    'Non chiare' = 33292291,
    'Non verificate' = 33292292,
    'Risolta' = 33292293,
    'Non risolvibile' = 33292294,
    'Undefined' = 0
}
export enum ProjectDataType {
    Requirements = 35913728,
    Needs = 35913729,
}

export enum BugSeverity {
  Undefined = 0,
  NonAssegnata = 36503552,
  Gravita1 = 36503553,
  Gravita2 = 36503554,
  Gravita3 = 36503555,
  Gravita4 = 36503556,
  Gravita5 = 36503557,
}
export enum BugPriority
{
  Nothing = 41680896,
  Alta = 41680897,
  Media = 41680898,
  Bassa = 41680899,
  DaAssegnare = 41680901
}

export enum InprovementStatus {
  DaApprovare = 35782656,
  Approvato = 35782657,
  InSviluppo = 35782658,
  Terminato = 35782659,
  InTesting = 35782664,
  Chiuso = 35782665,
  Sospeso = 35782666,
  Annullato = 35782660,
  Undefined = 0
}

